var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "z1t5wh3qda"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.274510 0 0 0 0 0.443137 0 0 0 0 0.819608 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1180 -200) translate(104 193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1076 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 24,
    x: 10.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 24,
    x: 10.5,
    rx: 1.5,
    transform: "rotate(90 12 12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAdd);
export default __webpack_public_path__ + "static/media/icons-add.54de94c77269cf90f06e9ea2eb2055fa.svg";
export { ForwardRef as ReactComponent };